import React from "react";
import axios from "axios";
import { useState, useEffect, useMemo } from "react";
import MaterialReactTable from "material-react-table";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faPencil,
  faTrash,
  faTrashAlt,
  faUpload,
} from "../../../node_modules/@fortawesome/free-solid-svg-icons/index";

const UploadSurveyLocation = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [surveyData, setSurveyData] = useState([]);
  const [fileName, setFileName] = useState("");
  let stateCodeLocal = sessionStorage.getItem("stateNameGlobal");
  let DstrictCodeLocal = sessionStorage.getItem("districtCodeGlobal");
  const [statesData, setStatesData] = useState([]);
  const [districtData, setDistrictData] = useState([]);
  const [stateValue, setStateValue] = useState("");
  const [districtValue, setDistrictValue] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {

    const result = await axios.post(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/iuusersmapping/getUniqueIUNotifiedArea`,
      {
        stateCode: stateCodeLocal === "0" ? stateValue === "Choose..." ? "" : stateValue : stateCodeLocal,
        districtCode: DstrictCodeLocal === "0" ? districtValue === "Choose..." ? "" : districtValue : DstrictCodeLocal,
        villageCode: "",
        cropCode: "",
        cropNotificationsID: "",
      }
    );
    setSurveyData(result.data.dataContent);
  };

  function getStates() {
    const fetchStates = async () => {
        const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Cropicstates`);
        setStatesData(result.data.dataContent);
    };
    fetchStates(); 
}

function handleState(value) {
    setStateValue(value);
    setDistrictData([])

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
        "stateCode": Number(value)
    });

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    };

    fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Cropicdistrict`, requestOptions)
        .then(response => response.text())
        .then(result => setDistrictData(JSON.parse(result).dataContent))
        .catch(error => console.log('error', error));
}



  function onFileChange(event, cell) {
   
    if (event.target.files[0].size > 5242880) {
      alert("File size should not be greater then 5 MB");
    } else {
      setSelectedFile(event.target.files[0]);
    
      document.getElementById(event.target.id).innerText = event.target.files[0].name;
    }

  }

  function onFileUpload(cell) {
   
    if (document.getElementById(cell.row.original.cropNotificationsID).files[0]) {
      var myHeaders = new Headers();
      myHeaders.append("accept", "*/*");

      var formdata = new FormData();
      formdata.append(
        "KMLFile",
        document.getElementById(cell.row.original.cropNotificationsID).files[0],
        document.getElementById(cell.row.original.cropNotificationsID).files[0].name
      );
      formdata.append("CreatedByUC", localStorage.getItem("userCodeGlobal"));
      formdata.append(
        "CropNotificationsID",
        cell.row.original.cropNotificationsID
      );

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/iuusersmapping/uploadIULocationKMLFiles`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          alert(JSON.parse(result).message);
          if (JSON.parse(result).success) {
           fetchDataUpload()
          }
        })
        .catch((error) => console.log("error", error));
    } else {
      alert("Select .KML File");
    }
  }

 async function fetchDataUpload() {
  let stateValueLocal = document.getElementById("State").value;
  let districtValueLocal = document.getElementById("District").value;
    const result = await axios.post(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/iuusersmapping/getUniqueIUNotifiedArea`,
      {
        stateCode: stateCodeLocal === "0" ?  stateValueLocal === "Choose..." ? "" : stateValueLocal : stateCodeLocal,
        districtCode: DstrictCodeLocal === "0" ? districtValueLocal === "Choose..." ? "" : districtValueLocal : DstrictCodeLocal,
        villageCode: "",
        cropCode: "",
        cropNotificationsID: "",
      }
    );
    setSurveyData(result.data.dataContent);
  }

  function onFileDelete(cell) {
    var myHeaders = new Headers();
    myHeaders.append("accept", "/");
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      "allocationCode": cell.row.original.allocationCode,
    });

    var requestOptions = {
      method: "DELETE",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/iuusersmapping/deleteIULocationKMLFiles`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        alert(JSON.parse(result).message);
        if (JSON.parse(result).success) {
          fetchDataUpload();
        }
      })
      .catch((error) => console.log("error", error));
  }

  function handleFilter() {
    if( stateValue || districtValue ) {
      fetchData();
      
        document.getElementById("clearBtn").disabled = false;


    } else {
        alert("Select Any Field to Filter")
    }

}

async function handleClearFilter() {
  setStateValue("")
  setDistrictValue("")
 const result = await axios.post(
  `${
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_DEV_MODE
      : process.env.REACT_APP_PRO_MODE
  }/api/iuusersmapping/getUniqueIUNotifiedArea`,
  {
    stateCode: stateCodeLocal === "0" ? "" : stateCodeLocal,
    districtCode: DstrictCodeLocal === "0" ? "" : DstrictCodeLocal,
    villageCode: "",
    cropCode: "",
    cropNotificationsID: "",
  }
);
setSurveyData(result.data.dataContent);
}

  const columns = useMemo(
    () => [
      {
        header: "S.No",
        Cell: (cell) => Number(cell.row.id) + 1,
      },

      {
        accessorKey: "stateName",
        header: "State Name",
      },

      {
        accessorKey: "districtName",
        header: "District Name",
      }, 
      {
        accessorKey: "level4Name",
        header: "Level4 Name",
      },
      {
        accessorKey: "level5Name",
        header: "Level5 Name",
      },
      {
        accessorKey: "level6Name",
        header: "Level6 Name",
      }, 
      {
        accessorKey: "villageName",
        header: "Village Name",
      },
      {
        accessorKey: "notifiedIUName",
        header: "Notified IU Name",
      },
      {
        accessorKey: "cropName",
        header: "Crop Name",
      },

      {
        accessorKey: "attName",
        header: "File Name",
      },

      {
        accessor: "",
        header: "Actions",
        Cell: (cell) =>
          cell.row.original.attName ? (
            <>
              <button
                className="btn btn-danger btn-sm uploadkml2"
                onClick={() => onFileDelete(cell)}
              >
                Delete
              </button>
               
            </>
          ) : (
            <>
              {/* <label htmlFor="fileInput">
                {" "}
              </label> */}
              <input
                type="file"
                className="form-control fileuploads"
                 id={cell.row.original.cropNotificationsID}
                accept=".kml"
                onChange={(event) => onFileChange(event, cell )}
              />

              <button
                className="btn btn-info btn-sm uploadkml2"
                onClick={() => onFileUpload(cell)}
              >
                Upload
              </button>
            </>
          ),
      },
    ],
    []
  );

  {
  
  }

  return (
    <>
      <main id="main" className="main">
        <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
          <nav>
            <h1>Upload Survey Location</h1>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">User Management</li>
              <li className="breadcrumb-item active">Upload KML File</li>
            </ol>
          </nav>
        </div>


        <div className="card">
                                <div className="card-body">
                                    <form className="row g-3">
                                                                             
                                        <div className="col-md-3">
                                            <label htmlFor="State" className="form-label">State</label>
                                            <select id="State" required className="form-select" onClick={getStates} onChange={(e) => handleState(e.target.value)} value={stateValue}>
                                                <option defaultValue>Choose...</option>
                                                {statesData.map((item, id) => {
                                                    return <option key={id} value={item.stateCode}> {item.stateName}</option>
                                                })}
                                            </select>
                                        </div>
                                        <div className="col-md-3">
                                            <label htmlFor="District" className="form-label">District</label>
                                            <select id="District" className="form-select" onChange={(e) => setDistrictValue(e.target.value)} value={districtValue}>
                                                <option defaultValue>Choose...</option>

                                                {districtData.map((item, id) => {
                                                    return <option key={id} value={item.districtCode}> {item.districtName}</option>
                                                })}
                                            </select>
                                        </div>  
                                        <div className="col-md-3">
                                          <label className="col-md-12 mt-1">&nbsp;</label>
                                          <button type="button" className="btn btn-primary me-md-2" id="findBtn" onClick={handleFilter}>Find</button>
                                          <button type="button" className="btn btn-primary me-md-2" onClick={handleClearFilter} id="clearBtn">Clear</button>
                                        </div> 
                                    </form>
                                </div>

                            </div>

        

        <div className="row justify-content-lg-center">
          <div className="col-lg-12 ">
            <div className="card">
              <MaterialReactTable
                columns={columns}
                data={surveyData}
                enableColumnOrdering
                enablePagination={true}
              />
            </div>
          </div>
        </div>
      </main>
    </>
  );
};
export default UploadSurveyLocation;
